import React, { useCallback, useState } from 'react';
import { PATIENT_STATUSES } from 'src/constants';
import styled from 'styled-components/native';
import PatientListContent from './components/PatientListContent';
import { useAppTheme } from 'src/providers/AppThemeProvider';
import { SliderElement, SLIDES, STEPS } from '../../routes/stacks/PatientStackNavigator/tour';
import SidebarPatientTypeSelector from './components/SidebarPatientTypeSelector';
import { LayoutAnimation } from 'react-native';
import FloatingPawPath from 'src/components/FloatingPawPath';
import { Patient } from 'src/interfaces';
import { useFocusEffect } from '@react-navigation/native';

interface Props {
  petNavOverride?: (id: Patient['patientId']) => void;
}
const PatientListRoot: React.FC<Props> = ({ petNavOverride }) => {
  const { viewMode } = useAppTheme();

  const [selectedStatus, setSelectedStatus] = useState<PATIENT_STATUSES | undefined>(
    PATIENT_STATUSES.ACTIVE
  );

  const [isOpen, setOpen] = useState(viewMode.isWeb);

  useFocusEffect(
    useCallback(() => {
      if (viewMode.isWeb) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    }, [viewMode.isWeb])
  );

  const toggleOpen = () => {
    if (!viewMode.isWeb) {
      LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
      setOpen((prev) => !prev);
    }
  };
  return (
    <>
      <ResponsiveContainer>
        <SidebarPatientTypeSelector
          isOpen={isOpen}
          toggleOpen={toggleOpen}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
        />
        <PatientListContent
          petNavOverride={petNavOverride}
          patientStatus={selectedStatus}
          toggleOpen={toggleOpen}
          selectedStatus={selectedStatus}
          filterIsOpen={isOpen}
        />
      </ResponsiveContainer>
      <SliderElement id={STEPS.DRAWER} slides={SLIDES} autoStart />
      <FloatingPawPath />
    </>
  );
};

export default PatientListRoot;

const ResponsiveContainer = styled.View`
  flex-direction: ${({ theme }) => (theme.viewMode.isWeb ? 'row' : 'col')};
  flex: 1;
`;
